module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "activeMenu": "messages"
    }
  }, [_c('v-panel', [_c('div', {
    staticClass: "page-header-wrapper",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "page-header-wrapper message-page",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "market-filter-area"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3 speakers-section border-right"
  }, [_c('div', {
    staticClass: "col-12 title-section"
  }, [_c('div', {
    staticClass: "booking_tle row"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "booking-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/notebook.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {}, [_vm._v(_vm._s(_vm.$t('messages.index.messages')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb-0 sort-by-date"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortByValue),
      expression: "sortByValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sortByValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.sortBy(_vm.sortByValue)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "booking"
    }
  }, [_vm._v(_vm._s(_vm.$t('messages.index.sort_by_booking_date')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "message"
    }
  }, [_vm._v(_vm._s(_vm.$t('messages.index.sort_by_message_date')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-search"
  }, [_c('button', {
    staticClass: "input-search-btn",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "icon md-search",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('messages.index.search_keyword'),
      "name": ""
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "threads",
    staticClass: "speakers-block"
  }, [_c('div', {
    class: _vm.bookings.length === 0 ? 'speakers no-bookings-yet' : 'speakers'
  }, [(_vm.bookings.length > 0) ? _c('div', _vm._l((_vm.bookings), function(booking, index) {
    return _c('div', {
      ref: "thread",
      refInFor: true,
      staticClass: "speaker",
      class: _vm.activeBooking === index ? 'active' : '',
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setActiveBooking(index)
        }
      }
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('div', {
      staticClass: "row signed-and-time"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (booking.unread),
        expression: "booking.unread"
      }],
      staticClass: "circle signed"
    }, [_vm._v(_vm._s(_vm.$t('messages.index.unread')))])]), _vm._v(" "), (booking.last_message_at) ? _c('div', {
      staticClass: "col-6 signed-time-ago"
    }, [_vm._v("\n                              " + _vm._s(_vm.ago(booking.last_message_at)) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-2"
    }, [_c('img', {
      staticClass: "speaker-image",
      attrs: {
        "src": "static/material/global/portraits/avatar.png",
        "alt": "..."
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-7 booking-info"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(booking.guest.first_name) + " " + _vm._s(booking.guest.last_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.date(booking.checking)) + " - " + _vm._s(_vm.add(booking.checking, booking.checkout)))]), _vm._v(" "), _c('div', {
      staticClass: "m-t-5"
    }, [_vm._v(_vm._s(booking.rental.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-3 text-right"
    }, [_c('i', {
      staticClass: "icon-rental-moon"
    }), _vm._v(" "), _c('span', {
      staticClass: "message-nb-nights"
    }, [_vm._v(_vm._s(_vm._f("calculateNight")(booking.checking, booking.checkout)))])])])])])
  })) : (!_vm.messagesLoading && !_vm.bookings.length) ? _c('div', [_c('div', {
    staticClass: "col-12 messages-section border-right"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('messages.index.no_bookings_yet')) + "\n                        ")])]) : _vm._e()])]), _vm._v(" "), _c('ul', {
    staticClass: "pagination justify-content-center align-items-center"
  }, [_c('li', {
    staticClass: "page-item px-10"
  }, [_c('button', {
    staticClass: "btn btn-red",
    class: _vm.offset <= 0 || _vm.totalBookings === 0 ? 'disabled' : '',
    attrs: {
      "disabled": _vm.offset <= 0 || _vm.totalBookings === 0,
      "aria-label": "Previous"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.prevPage()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(_vm._s(_vm.$t("button.prev")))])])]), _vm._v(" "), _c('li', {
    staticClass: "active page-item"
  }), _vm._v(" "), _c('li', {
    staticClass: "page-item px-10"
  }, [_c('button', {
    staticClass: "btn btn-red",
    class: _vm.offset + _vm.limit >= _vm.totalBookings || _vm.totalBookings === 0 ? 'disabled' : '',
    attrs: {
      "disabled": _vm.offset + _vm.limit >= _vm.totalBookings || _vm.totalBookings === 0,
      "aria-label": "Next"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.nextPage()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.next')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-9 right-section row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.messagesLoading && _vm.bookings.length > 0),
      expression: "!messagesLoading && bookings.length > 0 "
    }],
    staticClass: "col-8 messages-section border-right"
  }, [_c('div', {
    staticClass: "empty-row title-section"
  }), _vm._v(" "), _c('div', {
    ref: "messages",
    staticClass: "messages"
  }, _vm._l((_vm.messages), function(message) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (message.text != ''),
        expression: "message.text != ''"
      }],
      class: ("row messages-item " + (message.from === 'user' ? 'justify-content-end' : 'justify-content-start'))
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (message.from == 'user'),
        expression: "message.from == 'user'"
      }],
      staticClass: "col-lg-6 col-sm-11"
    }, [_c('div', {
      class: (message.type == 'note') ? 'message-text my-message-note' : (message.type == 'reminder') ? 'message-text my-message-reminder' : 'message-text my-message'
    }, [_c('pre', {
      domProps: {
        "innerHTML": _vm._s(message.text)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "message-info text-right"
    }, [_vm._v(_vm._s(_vm.date_detail(message.created_at)))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (message.from == 'user'),
        expression: "message.from == 'user'"
      }],
      staticClass: "col-1"
    }, [_c('img', {
      staticClass: "avatar-image",
      attrs: {
        "src": message.user && message.user.avatar ? message.user.avatar : 'static/material/global/portraits/avatar.png',
        "alt": "..."
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "message-info text-center"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (message.type == 'note' && message.from_auto_action),
        expression: "message.type == 'note' && message.from_auto_action"
      }],
      staticClass: "font-size-10"
    }, [_vm._v("Note Sms")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (message.from == 'guest'),
        expression: "message.from == 'guest'"
      }],
      staticClass: "col-1"
    }, [_c('img', {
      staticClass: "avatar-image",
      attrs: {
        "src": "static/material/global/portraits/avatar.png",
        "alt": "..."
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (message.from == 'guest'),
        expression: "message.from == 'guest'"
      }],
      staticClass: "col-lg-6 col-sm-11"
    }, [_c('div', {
      staticClass: "message-text speakers-message"
    }, [_c('pre', {
      domProps: {
        "innerHTML": _vm._s(message.text)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "message-info text-left"
    }, [_vm._v(_vm._s(_vm.date_detail(message.created_at)))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "send-message-section"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10 col-md-8"
  }, [_c('div', {
    staticClass: "radio-cont"
  }, [_c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.type),
      expression: "message.type"
    }],
    attrs: {
      "type": "radio",
      "id": "messagemail",
      "value": "mail"
    },
    domProps: {
      "checked": _vm._q(_vm.message.type, "mail")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.message, "type", "mail")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "messagemail"
    }
  }, [_vm._v(_vm._s(_vm.labelName))])]), _vm._v(" "), (_vm.selectedThreadSms) ? _c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.type),
      expression: "message.type"
    }],
    attrs: {
      "type": "radio",
      "id": "messagesms",
      "value": "sms"
    },
    domProps: {
      "checked": _vm._q(_vm.message.type, "sms")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.message, "type", "sms")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "messagesms"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.sms')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.type),
      expression: "message.type"
    }],
    attrs: {
      "type": "radio",
      "id": "messagenote",
      "value": "note"
    },
    domProps: {
      "checked": _vm._q(_vm.message.type, "note")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.message, "type", "note")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "messagenote"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.note')))])]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-primary radio-whatsapp"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.type),
      expression: "message.type"
    }],
    attrs: {
      "type": "radio",
      "id": "whatsapp",
      "value": "whatsApp"
    },
    domProps: {
      "checked": _vm._q(_vm.message.type, "whatsApp")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.message, "type", "whatsApp")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "whatsapp"
    }
  }, [_c('i', {
    staticClass: "far fa-whatsapp"
  }), _vm._v("  WhatsApp")])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 d-flex cursor-pointer",
    on: {
      "click": function($event) {
        _vm.showTemplates()
      }
    }
  }, [_c('svg', {
    staticClass: "app-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 60 60"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.9 46.4H7.8c-3.2 0-5.8-2.6-5.8-5.8V11.8C2 8.6 4.6 6 7.8 6h43.4c3.2 0 5.8 2.6 5.8 5.8v28.9c0 3.2-2.6 5.8-5.8 5.8H30.1l-11.2 7c-1.9 1.2-4.3.6-5.5-1.3-.4-.6-.6-1.4-.6-2.1v-3.7zm4.3 3l11.7-7.3h22.3c.8 0 1.4-.6 1.4-1.4V11.8c0-.8-.6-1.4-1.4-1.4H7.8c-.8 0-1.4.6-1.4 1.4v28.9c0 .8.6 1.4 1.4 1.4h9.4v7.3zm10-12.2c-2.4 1.5-5.5.7-7-1.7-.7-1.1-.9-2.5-.6-3.8l.6-2.5-1.9-1.7c-2.1-1.8-2.4-5-.6-7.1.9-1 2.1-1.6 3.4-1.7l2.5-.2 1-2.3c1.1-2.6 4-3.8 6.6-2.7 1.2.5 2.2 1.5 2.7 2.7l1 2.3 2.5.2c2.8.2 4.9 2.7 4.6 5.4-.1 1.3-.7 2.6-1.8 3.4l-1.9 1.7.6 2.5c.6 2.7-1 5.4-3.8 6.1-1.3.3-2.7.1-3.8-.6l-2.2-1.3-1.9 1.3zm2.2-6.4l4.4 2.7c.2.1.4.1.5.1.4-.1.6-.5.5-.9l-1.2-5 3.9-3.4c.1-.1.2-.3.3-.5 0-.4-.3-.7-.7-.8l-5.2-.4-2-4.8c-.1-.2-.2-.3-.4-.4-.4-.2-.8 0-.9.4l-2 4.8-5 .4c-.2 0-.4.1-.5.2-.3.3-.2.8.1 1l3.9 3.4-1.2 5c0 .2 0 .4.1.5.2.3.7.4 1 .2l4.4-2.5z"
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "m-l-10 text-uppercase cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t('message_templates.template')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-4"
  }, [_c('div', {
    staticClass: "row d-flex justify-content-end"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reminderTime == 6),
      expression: "reminderTime == 6"
    }],
    staticClass: "col-7 m-t-5"
  }, [_c('span', [_c('date-picker', {
    ref: "reminder-picker",
    staticClass: "datepicker",
    attrs: {
      "type": "datetime",
      "lang": "en",
      "not-before": new Date(),
      "clearable": true,
      "width": "100%",
      "input-class": "mx-input input-date",
      "time-picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      },
      "confirm": "",
      "format": "MMM DD, YYYY, HH:mm a"
    },
    model: {
      value: (_vm.customDateSelected),
      callback: function($$v) {
        _vm.customDateSelected = $$v
      },
      expression: "customDateSelected"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reminderTime == 7 || _vm.reminderTime == 8 || _vm.reminderTime == 9 || _vm.reminderTime == 10),
      expression: "reminderTime == 7 || reminderTime == 8 || reminderTime == 9 || reminderTime == 10"
    }],
    staticClass: "col-4 before-after-time"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beforeOrAfterDays),
      expression: "beforeOrAfterDays"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.beforeOrAfterDays = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((200), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('div', {
    staticClass: "radio-cont justify-content-end"
  }, [_c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('div', {
    staticClass: "dropdown padding-none dropup"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.type),
      expression: "message.type"
    }],
    attrs: {
      "type": "radio",
      "id": "message-reminder",
      "value": "reminder",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.message.type, "reminder")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.message, "type", "reminder")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "message-reminder"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.reminder')))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right reminder-dropdown"
  }, [_c('ul', {
    staticClass: "reminder-list"
  }, [_c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 1 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.one_hour")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 2 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.two_hour")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 3 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(3)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.same_time_tomorrow")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 4 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(4)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.same_time_two_days")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 5 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(5)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.same_time_one_week")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 7 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(7)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.after_checking")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 8 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(8)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.after_checkout")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 9 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(9)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.before_checking")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 10 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(10)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.before_checkout")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 6 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(6)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.custom_time")))])])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "message-label"
  }, [_vm._v(_vm._s(_vm.$t('messages.index.type_your_message')))]), _vm._v(" "), _c('div', {
    staticClass: "panel-content-inner"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.text),
      expression: "message.text"
    }],
    ref: "message-textarea",
    staticClass: "form-control",
    attrs: {
      "cols": "30",
      "rows": "3",
      "required": "required"
    },
    domProps: {
      "value": (_vm.message.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.message, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "send-button-section"
  }, [_c('button', {
    staticClass: "btn btn-red send-button",
    attrs: {
      "disabled": _vm.sendButtonDisable
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onSend(_vm.bookings[_vm.activeBooking].user, _vm.bookings[_vm.activeBooking].id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('messages.index.send')))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messagesLoading),
      expression: "messagesLoading"
    }],
    staticClass: "col-8 row loader-wrapper"
  }, [_c('div', {
    staticClass: "md-preloader"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "height": "75",
      "width": "75",
      "viewbox": "0 0 75 75"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "37.5",
      "cy": "37.5",
      "r": "33.5",
      "stroke-width": "4",
      "stroke": "#D7092E"
    }
  })])])]), _vm._v(" "), (_vm.bookings.length > 0) ? _c('div', {
    staticClass: "col-4 result-section"
  }, [_c('div', [_c('div', {
    staticClass: "col-12 title-section p-l-0 short-center"
  }, [_c('div', {
    staticClass: "booking_tle text-uppercase"
  }, [_c('i', {
    staticClass: "icon-rental-user"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "range-section"
  }, [_c('div', {
    staticClass: "short-center"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('messages.index.status')))]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('messages.index.duration')))])]), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-600 font-size-12"
  }, [_c('div', {
    staticClass: "col-6 text-green"
  }, [_c('span', [_vm._v(_vm._s(_vm.getBookingStatusName(_vm.bookings[_vm.activeBooking].status, _vm.bookings[_vm.activeBooking].statusCode, _vm.bookings[_vm.activeBooking].payment_is_done)))])]), _vm._v(" "), (_vm.bookings && _vm.bookings[_vm.activeBooking]) ? _c('div', {
    staticClass: "col-6"
  }, [_vm._v(_vm._s(_vm._f("calculateNight")(_vm.bookings[_vm.activeBooking].checking, _vm.bookings[_vm.activeBooking].checkout)) + " " + _vm._s(_vm.$t('messages.index.nights')) + " ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "pt-20"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('messages.index.check_in')))]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('messages.index.check_out')))])]), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-600 font-size-12"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_vm._v(_vm._s(_vm.date(_vm.bookings[_vm.activeBooking].checking)) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_vm._v(_vm._s(_vm.date(_vm.bookings[_vm.activeBooking].checkout)))])])]), _vm._v(" "), _c('div', {
    staticClass: "pt-20"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('messages.index.platform')))]), _vm._v(" "), ((_vm.user.is_team_member && _vm.user.rights && _vm.user.rights.booking_prices) || !_vm.user.is_team_member) ? _c('div', {
    staticClass: "col-6 text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('messages.index.total_price')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-600 font-size-12"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_vm._v(_vm._s(_vm.bookings[_vm.activeBooking].channel ? _vm.bookings[_vm.activeBooking].channel.name : ''))]), _vm._v(" "), ((_vm.user.is_team_member && _vm.user.rights && _vm.user.rights.booking_prices) || !_vm.user.is_team_member) ? _c('div', {
    staticClass: "col-6"
  }, [_vm._v(_vm._s(_vm.getPriceAmount(_vm.bookings[_vm.activeBooking])) + " " + _vm._s(_vm.currency))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "center-section"
  }, [_c('div', {
    staticClass: "short-center name-image"
  }, [_c('i', {
    staticClass: "far fa-building"
  }), _vm._v(" "), _c('a', {
    staticClass: "text-uppercase color-pink font-weight-600 pl-2",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.gotoRentalDetails()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.bookings[_vm.activeBooking].rental.name))])]), _vm._v(" "), _c('div', {
    staticClass: "short-center pt-15"
  }, [_c('div', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('messages.index.total_guests')))]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-600"
  }, [_vm._v(_vm._s(_vm.bookings[_vm.activeBooking].nbr_adults + _vm.bookings[_vm.activeBooking].nbr_children))])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-section"
  }, [((_vm.user.is_team_member && _vm.user.rights && _vm.showBookingPrices && _vm.showBookingActions) || !_vm.user.is_team_member) ? _c('div', {
    staticClass: "listing"
  }, [_c('a', {
    staticClass: "color-pink font-weight-600 pl-2",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.gotoBookingDetails()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('messages.index.booking_details')) + " ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row pt-25"
  }, [_c('div', {
    staticClass: "col-3"
  }, [(_vm.bookings[_vm.activeBooking].rental.photo) ? _c('img', {
    staticClass: "avatar-image",
    attrs: {
      "src": _vm.bookings[_vm.activeBooking].rental.photo,
      "alt": "..."
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  })])])]) : _vm._e()])])])]), _vm._v(" "), _c('v-import-new-airbnb-rentals', {
    ref: "airbnbImportModal"
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.templateDetails),
      expression: "templateDetails"
    }],
    staticClass: "calendar-month-view"
  }, [_c('div', {
    staticClass: "panel messages-panel panel-white left"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.isTemplateDeleting
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTemplateDeleting),
      expression: "!isTemplateDeleting"
    }],
    staticClass: "pannel_sec"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('h2', {
    staticClass: "tle_p head-messages"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message_templates.title')) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('span', {
    staticClass: "cross_icon font-size-30",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeTemplates()
      }
    }
  }, [_vm._v("x")])])])]), _vm._v(" "), _c('div', {
    staticClass: "pannel_details"
  }, [_c('div', {
    staticClass: "message-templates"
  }, [_c('div', {
    staticClass: "row m-t-25"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "radio-cont"
  }, [_c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showTemplateType),
      expression: "showTemplateType"
    }],
    attrs: {
      "type": "radio",
      "id": "general-templates",
      "value": "notification"
    },
    domProps: {
      "checked": _vm._q(_vm.showTemplateType, "notification")
    },
    on: {
      "change": function($event) {
        _vm.showTemplateType = "notification"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "general-templates"
    }
  }, [_vm._v(_vm._s(_vm.$t('message_templates.notification')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified template-info",
    attrs: {
      "title": _vm.$t('booking.detail.notification_template_info')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showTemplateType),
      expression: "showTemplateType"
    }],
    attrs: {
      "type": "radio",
      "id": "user-templates",
      "value": "general"
    },
    domProps: {
      "checked": _vm._q(_vm.showTemplateType, "general")
    },
    on: {
      "change": function($event) {
        _vm.showTemplateType = "general"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user-templates"
    }
  }, [_vm._v(_vm._s(_vm.$t('message_templates.my_templates')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified template-info",
    attrs: {
      "title": _vm.$t('booking.detail.general_template_info')
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newTemplateOpen && _vm.showTemplateType !== 'notification'),
      expression: "newTemplateOpen && showTemplateType !== 'notification'"
    }],
    staticClass: "row p-side-2"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('form', {
    staticClass: "m-t-15",
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.messageTemplate.id ? _vm.updateTemplate() : _vm.createTemplate()
      }
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "template-name"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.name")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageTemplate.name),
      expression: "messageTemplate.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "template-name",
      "required": ""
    },
    domProps: {
      "value": (_vm.messageTemplate.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.messageTemplate, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group mb-20"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t('message_templates.message')))]), _vm._v(" "), _c('div', {
    staticClass: "panel-content-inner mb-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageTemplate.body),
      expression: "messageTemplate.body"
    }],
    staticClass: "form-control",
    attrs: {
      "cols": "30",
      "rows": "3",
      "required": "",
      "id": "message-template-body"
    },
    domProps: {
      "value": (_vm.messageTemplate.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.messageTemplate, "body", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "cursor-pointer open-shortcodes-button-msg",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openShortcodeListModal('#shortcode-list-modal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.show_shortcode_list")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(!_vm.messageTemplate.id) ? _c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelNewTemplateAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("button.cancel")))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.saveTemplateDisabled
    }
  }, [_vm._v(_vm._s(_vm.$t("button.save")))])]), _vm._v(" "), _c('VShortCodeListModal', {
    attrs: {
      "selectedShortCode": _vm.selectedShortCode,
      "shortCodeName": _vm.shortCodeName
    },
    on: {
      "insertShortcodeToText": _vm.insertShortcodeToText,
      "closeAndOpenModals": _vm.closeAndOpenModals,
      "changeSelectedShortCode": _vm.changeSelectedShortCode
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-15"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.templateLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTemplateType === 'notification'),
      expression: "showTemplateType === 'notification'"
    }]
  }, _vm._l((_vm.notifications), function(notification, index) {
    return _c('div', {
      staticClass: "template-container m-t-15",
      on: {
        "click": function($event) {
          _vm.openBody(index, 'notification', $event)
        }
      }
    }, [_c('div', {
      staticClass: "template",
      class: notification.body_open ? 'template-body-open box' : ''
    }, [_c('p', {
      staticClass: "d-inline-block template-name"
    }, [_vm._v(_vm._s(notification.title))]), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn btn-primary waves-effect waves-classic btn-save",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.insertBody(index, 'notification', _vm.bookings[_vm.activeBooking].id)
        }
      }
    }, [_vm._v("+ " + _vm._s(_vm.$t("button.insert")))])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.body_open),
        expression: "notification.body_open"
      }],
      staticClass: "template template-body-open body"
    }, [_c('pre', {
      domProps: {
        "innerHTML": _vm._s(notification.message)
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTemplateType == 'general'),
      expression: "showTemplateType == 'general'"
    }]
  }, [_c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    class: _vm.newTemplateOpen && 'hidden',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.newTemplateOpen = !_vm.newTemplateOpen
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.add")))]), _vm._v(" "), _vm._l((_vm.userTemplates), function(template, index) {
    return _c('div', {
      staticClass: "template-container m-t-15",
      on: {
        "click": function($event) {
          _vm.openBody(index, 'user', $event)
        }
      }
    }, [_c('div', {
      staticClass: "template",
      class: template.body_open ? 'template-body-open box' : ''
    }, [_c('p', {
      staticClass: "d-inline-block template-name"
    }, [_vm._v(_vm._s(template.name))]), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn btn-primary waves-effect waves-classic btn-save",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.insertBody(index, 'user', _vm.bookings[_vm.activeBooking].id)
        }
      }
    }, [_vm._v("+ " + _vm._s(_vm.$t("button.insert")))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-edit waves-effect waves-classic btn-save",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editTemplate(template.id, index, 'template', $event)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-edit"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-delete waves-effect waves-classic btn-save",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteTemplate(template.id, index, 'template', $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (template.body_open),
        expression: "template.body_open"
      }],
      staticClass: "template template-body-open body"
    }, [_c('pre', {
      domProps: {
        "innerHTML": _vm._s(template.body)
      }
    })])])
  })], 2)], 1)])])])])], 1)])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16aa1bc5"}!./src/app/pages/messages/index/index.html
// module id = 1341
// module chunks = 0